import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M20.57 2.74998C24.03 4.85998 28.15 11.27 27.78 27.12C27.41 42.97 17.96 63.49 4.73997 59.2C4.73997 59.2 11.63 57.96 9.29997 45.71C6.96997 33.46 2.26999 21.18 6.00999 9.72998C9.19999 -0.0400219 17.53 0.889979 20.57 2.74998Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M7.22998 59.3301C7.22998 59.3301 14.38 57.8201 14.54 47.3201C14.8 29.7301 9.74996 15.2301 19.65 5.1001C19.65 5.1001 18.83 7.4401 20.75 23.1601C22.02 33.6001 21.68 57.1301 9.72998 59.3901"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M19.65 5.1101C19.65 5.1101 4.9 3.5701 10.66 35.8101C13.33 50.7701 11.81 57.2101 7.64001 58.7001"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M78.9899 2.74998C75.5299 4.85998 71.41 11.27 71.78 27.12C72.15 42.97 81.6 63.49 94.82 59.2C94.82 59.2 87.93 57.96 90.26 45.71C92.59 33.46 97.2899 21.18 93.5499 9.72998C90.3699 -0.0400219 82.0399 0.889979 78.9899 2.74998Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M92.3299 59.3301C92.3299 59.3301 85.1799 57.8201 85.0199 47.3201C84.7599 29.7301 89.8099 15.2301 79.9099 5.1001C79.9099 5.1001 80.7299 7.4401 78.8099 23.1601C77.5399 33.6001 77.8799 57.1301 89.8299 59.3901"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M79.9099 5.1101C79.9099 5.1101 94.6599 3.5701 88.8999 35.8101C86.2299 50.7701 87.7499 57.2101 91.9199 58.7001"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
    </g>
  )
}
